import React, { createContext, useContext } from "react";
import { FilterBody } from "../../../hooks/filter/typing";
import { ItemsInput } from "../pages/main/typing/types";

export const QuestionnaireFormContext = createContext<{ 
    state: any; setState: React.Dispatch<any> 
    paginationMain: FilterBody
    allDepartments: any[]
    itemsSearch: ItemsInput
    setAllDepartments: React.Dispatch<React.SetStateAction<any[]>>
    setItemsSearch: React.Dispatch<React.SetStateAction<ItemsInput>>
}>(Object({}))

export const useQuestionnaireContext = () => useContext(QuestionnaireFormContext)
